export const drivePublicRedirectionReasonKey = 'drivePublicRedirectionReason'

export enum RedirectionReason {
  ACCOUNT_SWITCH = 'accountSwitch',
}
